import { useI18nContext } from './useI18nContext';
import type { UseTranslationReturn } from './types';

export function useTranslation(): UseTranslationReturn {
  const { t, language, setLanguage } = useI18nContext();
  
  return {
    t,
    language,
    setLanguage,
  };
}
